export default __webpack_public_path__ + "CarePlayQRAndroid.png";